import enUS from "@/i18n/en_US";
import ptBR from "@/i18n/pt_BR";
import esES from "@/i18n/es_ES";

import {
  getScale,
  getColorsArray,
  isFilled,
  roundedValue,
  getColor,
  multipleChoiceLetters,
  optionOtherLabel
} from "./surveyEmailUtils";
import { QUESTION_TYPE } from "../consts/survey";
const URL_SURVEY = "{{data.survey-link}}";
const IMG_URL = window.location.origin;

const placeholderInput = {
  en_US: enUS.survey.new.placeholder_answer,
  pt_BR: ptBR.survey.new.placeholder_answer,
  es_ES: esES.survey.new.placeholder_answer
};

/**
 * Get the email layout for the first survey question
 * Will need some question item attributes
 * @param {the item to create email layout} surveyItem
 * @param {survey default language} surveyLanguage
 */
export default function getEmailLayout(surveyItem, surveyLanguage) {
  let scaleType = surveyItem.item.scale_type;
  if (surveyItem.type === QUESTION_TYPE.NPS_TRANSACTIONAL || surveyItem.type === QUESTION_TYPE.NPS_RELATIONAL) {
    scaleType = 0;
  }
  const labelMin = surveyItem.item.button_subtitle_min ? surveyItem.item.button_subtitle_min[surveyLanguage] : null;
  const labelMax = surveyItem.item.button_subtitle_max ? surveyItem.item.button_subtitle_max[surveyLanguage] : null;

  let layout =
    '<table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" style="width: 100%!important"><tbody><tr><td>';

  layout += getEmailQuestion(surveyItem.item.question, surveyLanguage);
  if (surveyItem.type === QUESTION_TYPE.RATINGS) {
    layout += getRatingButtons(surveyItem.item.max_scale);
  } else if (surveyItem.type === QUESTION_TYPE.MULTIPLE_CHOICE) {
    layout += getMultipleChoiceButtons(surveyItem.item.options, surveyLanguage, surveyItem.item.option_other);
  } else if (surveyItem.type === QUESTION_TYPE.EMOJI) {
    layout += getEmojiButtons();
  } else if (surveyItem.type === QUESTION_TYPE.THUMBS) {
    layout += getThumbsButtons();
  } else if (surveyItem.type === QUESTION_TYPE.OPEN) {
    layout += getOpenButtons(surveyLanguage);
  } else {
    layout += getEmailButtons(
      surveyItem.item.min_scale,
      surveyItem.item.max_scale,
      surveyItem.item.inverted_scale,
      scaleType,
      surveyItem.item.color_pattern,
      surveyItem.item.custom_color,
      surveyItem.item.button_design,
      surveyItem.type,
      labelMin,
      labelMax,
      surveyLanguage
    );
  }

  layout += "</td></tr></tbody></table>";
  return layout;
}
/**
 * Function that will print the scale buttons in table for the Email layout
 * CES
 * CSAT
 * NPS Relational and Transactional
 * @param {min_scale} minScale
 * @param {max_scale} maxScale
 * @param {inverted_scale} reverse
 * @param {scale_type} scaleType
 * @param {color_pattern} colorPattern
 * @param {custom_color} customColor
 * @param {button_design} buttonDesign
 * @param {the type of the question} questionType
 * @param {button_subtitle_min in the language} labelMin
 * @param {button_subtitle_max in the language} labelMax
 */
function getEmailButtons(
  minScale,
  maxScale,
  reverse,
  scaleType,
  colorPattern,
  customColor,
  buttonDesign,
  questionType,
  labelMin,
  labelMax,
  language
) {
  const scale = getScale(minScale, maxScale, reverse, scaleType, questionType);
  const colors = getColorsArray(minScale, maxScale, reverse);
  const filled = isFilled(buttonDesign);
  const rounded = roundedValue(buttonDesign, scaleType);
  const width = scaleType === 0 ? "40px" : "75px";
  const height = scaleType === 0 ? "40px" : "60px";
  const fontSize = scaleType === 0 ? "16px" : "10px";

  let layout = "";
  layout += '<table align="center" border="0" cellpadding="0" cellspacing="0"><tbody>';
  layout += "<tr>";
  if (labelMin && scaleType === 0) {
    layout += `<td style="text-align: right; color: #979797;font-size: 12px;">${labelMin}</td>`;
  }
  scale.forEach((scale, index) => {
    const color = getColor(index, colorPattern, colors, customColor);
    const background = filled ? `background:${color}` : `border: 1px solid ${color};color: ${color}`;
    layout += `<td style="width:4px;line-height:0;font-size:0" width="4" ></td>`;
    layout += `<td align="center" valign="middle" style="width:${width};height:${height};border-radius:${rounded};${background}">
                    <a href="${URL_SURVEY}?first_answer=${
      scale.value ? scale.value : scale
    }" style="font-size:${fontSize};font-weight:bold;text-decoration:none;display:block" target="_blank" >
                        <span style="${filled ? "color:#ffffff" : "color: " + color}">${
      scale.label ? scale.label[language] : scale
    }</span>
                    </a>
                </td>`;
  });
  if (labelMax && scaleType === 0) {
    layout += `<td style="width:4px;line-height:0;font-size:0" width="4" ></td>`;
    layout += `<td style="text-align: left; color: #979797;font-size: 12px;">${labelMax}</td>`;
  }
  layout += "</tr></tbody></table>";

  return layout;
}
/**
 * Create buttons like ratings question
 * @param {max_scale} maxScale
 */
function getRatingButtons(maxScale) {
  let layout = "";
  layout += '<table align="center" border="0" cellpadding="0" cellspacing="0" style="width: 100%"><tbody>';
  layout += "<tr>";
  for (let i = 1; i <= maxScale; i++) {
    layout += `<td style="width:4px;line-height:0;font-size:0" width="4" ></td>`;
    layout += `<td align="center" valign="middle" style="width:40px;height:40px;">
                    <a href="${URL_SURVEY}?first_answer=${i}" style="text-decoration:none;display:block" target="_blank" >
                        <img src="${IMG_URL}/survey/star_ratings.png"/>
                    </a>
                </td>`;
  }

  layout += "</tr></tbody></table>";

  return layout;
}
/**
 * Create buttons like emoji question
 */
function getEmojiButtons() {
  let layout = "";
  layout +=
    '<table align="center" width="100%" border="0" cellpadding="0" cellspacing="0" style="width: 100%!important;text-align:center!important"><tbody>';
  layout += "<tr>";
  for (let i = 1; i <= 5; i++) {
    layout += `<td style="width:4px;line-height:0;font-size:0" width="4" ></td>`;
    layout += `<td align="center" valign="middle" style="width:40px;height:40px;">
                    <a href="${URL_SURVEY}?first_answer=${i}" style="text-decoration:none;display:block" target="_blank" >
                        <img src="${IMG_URL}/survey/emoji/type3/disable_${i}.png"/>
                    </a>
                </td>`;
  }

  layout += "</tr></tbody></table>";

  return layout;
}
/**
 * Create buttons like thumbs question
 */
function getThumbsButtons() {
  let layout = "";
  layout +=
    '<table align="center" border="0" cellpadding="0" cellspacing="0" style="width: 50%;text-align:center!important"><tbody>';
  layout += "<tr>";
  layout += `<td align="center" valign="middle" style="width:40px;height:40px;">
                    <a href="${URL_SURVEY}?first_answer=0" style="text-decoration:none;display:block" target="_blank" >
                        <img src="${IMG_URL}/survey/thumbs_down.png"/>
                    </a>
                </td>`;
  layout += `<td style="width:20px;line-height:0;font-size:0" width="10" ></td>`;
  layout += `<td align="center" valign="middle" style="width:40px;height:40px;">
                    <a href="${URL_SURVEY}?first_answer=1" style="text-decoration:none;display:block" target="_blank" >
                        <img src="${IMG_URL}/survey/thumbs_up.png"/>
                    </a>
                </td>`;

  layout += "</tr></tbody></table>";

  return layout;
}
/**
 *  Create buttons like multiple choice question
 * @param {the multiple choice options} options
 * @param {language to display} language
 * @param {other option in case of multiple choice} otherOption
 */
function getMultipleChoiceButtons(options, language, otherOption) {
  let layout = "";
  layout += '<table align="left" border="0" cellpadding="0" cellspacing="0"><tbody>';

  for (let i = 0; i < options.length; i++) {
    layout += "<tr>";
    layout += `<td align="left" valign="middle"  >
                    <a href="${URL_SURVEY}?first_answer=${options[i][language]}" style="color: #7f8fa4; text-decoration:none;display:block; " target="_blank" >
                        <p style="color: #7f8fa4;min-height: 22px;  font-size: 16px; border: 1px solid #828282;border-radius: 16px;">
                        <span style="color: #333759;opacity: 0.4; margin-left: 5px;margin-right: 5px;"><b> ${multipleChoiceLetters[i]}</b></span>
                        <span style="margin-right: 5px; margin-left: 5px">${options[i][language]}</span>
                        </p>
                    </a>
                </td>`;
    layout += "</tr>";
  }
  if (otherOption) {
    layout += "<tr>";
    layout += `<td align="left" valign="middle"  >
                    <a href="${URL_SURVEY}" style="color: #7f8fa4; text-decoration:none;display:block; " target="_blank" >
                        <p style="color: #7f8fa4;min-height: 22px;  font-size: 16px; ">
                        <span style="margin-right: 5px; margin-left: 5px">${optionOtherLabel[language]}</span>
                        </p>
                    </a>
                </td>`;
    layout += "</tr>";
  }

  layout += "</tr></tbody></table>";

  return layout;
}
/**
 * Create open question for email layout
 */
function getOpenButtons(language) {
  let layout = "";
  layout += '<table align="left" border="0" cellpadding="0" cellspacing="0" style="width: 100%"><tbody>';
  layout += "<tr>";
  layout += `<td align="left" valign="middle" style="width:40px;height:40px;">
                    <a href="${URL_SURVEY}?first_answer=0" style="text-decoration:none;display:block" target="_blank" >
                        <p style="color: #7f8fa4;border-bottom: 1px solid #7f8fa4;line-height: 40px;">${placeholderInput[language]}</p>
                    </a>
                </td>`;
  layout += "</tr></tbody></table>";

  return layout;
}
/**
 * Mount the line of the question in Email layout
 * @param {the text of the question in defined language} questionText
 */
function getEmailQuestion(questionText, language) {
  return `<table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" style="width:100%!important;margin-bottom: 35px"><tbody>
            <tr><td><b>${questionText[language]}</b></td>
          </tr></tbody></table>`;
}
